import { AZURE_APP_ID, REDIRECT_URI } from 'utils/env';
import { createMsalConfig, AuthClient } from './msal-client';

const tokenScopes = ['User.Read', 'openid', 'profile', 'Group.Read.All'];
const authClient = AuthClient(createMsalConfig(AZURE_APP_ID, REDIRECT_URI), tokenScopes);

export { authClient };
export { getUserImage } from './graph-api-client';
